import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceNonBreakingSpace',
    standalone: true,
})
export class ReplaceNonBreakingSpacePipe implements PipeTransform {
    transform(value: string): string {
        return value.replace(/(&nbsp;|\u00A0)/g, ' ');
    }
}
